/**
 * @generated SignedSource<<e50794762cdabda3b712cf6e1e658ebd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dividendsPage_DateDeleteMutation$variables = {
  effectiveDate: any;
};
export type dividendsPage_DateDeleteMutation$data = {
  readonly capTableDateDelete: {
    readonly deleted: boolean | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type dividendsPage_DateDeleteMutation = {
  response: dividendsPage_DateDeleteMutation$data;
  variables: dividendsPage_DateDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "effectiveDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "effectiveDate",
    "variableName": "effectiveDate"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_DateDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_DateDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83962586bef8ad0c5d4e18710cf8382a",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_DateDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_DateDeleteMutation(\n  $effectiveDate: ISO8601Date!\n) {\n  capTableDateDelete(effectiveDate: $effectiveDate) {\n    deleted\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "be24fb3b852ee9f5113cb24fb938c45f";

export default node;
